import React, { useState } from "react";
import { Formik, Form, Field } from "formik";
import { TextField, Button, Card, CardContent, Typography, Box, Link as MuiLink, IconButton, InputAdornment } from "@mui/material";
import { LoginSchema } from "../../validations/loginValidation";
import useAuth from "../../hooks/useAuth";
import { Link } from "react-router-dom";
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import CircularProgress from '@mui/material/CircularProgress';

const LoginForm = ({ onSubmitHandler, hideSignup = false, loading: externalLoading, forgotPasswordLink = "/forgot-password", hideForgotPassword = false }) => {

  // console.log("onSubmitGandler:", onSubmitHandler)
  const { loading: authLoading } = useAuth();
  const [showPassword, setShowPassword] = useState(false);
  const loading = externalLoading !== undefined ? externalLoading : authLoading;

  return (
    <Box
      sx={{
        display: "flex",
        height: "65vh",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#f5f5f5",
      }}
    >
      <Card sx={{ width: 400, padding: 2 }}>
        <CardContent>
          <Typography variant="h5" align="center" gutterBottom>
            Offenderlist
          </Typography>
          <Typography align="center" gutterBottom>
            Sign in to your account
          </Typography>

          <Formik
            initialValues={{ email: "", password: "" }}
            validationSchema={LoginSchema}
            
            onSubmit={onSubmitHandler}
          >
            {({ errors, touched }) => (
              <Form>
                <Field
                  as={TextField}
                  name="email"
                  label="Email"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  error={touched.email && Boolean(errors.email)}
                  helperText={touched.email && errors.email}
                />
                <Field
                  as={TextField}
                  name="password"
                  type={showPassword ? 'text' : 'password'}
                  label="Password"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  error={touched.password && Boolean(errors.password)}
                  helperText={touched.password && errors.password}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={() => setShowPassword((show) => !show)}
                          edge="end"
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                />

                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  fullWidth
                  sx={{ mt: 2, borderRadius: 1, fontSize: 14 }}
                  disabled={loading}
                  startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null}
                >
                  Login
                </Button>
              </Form>
            )}
          </Formik>

          <Box mt={2} textAlign="center">
            {!hideForgotPassword && (
              <MuiLink component={Link} to={forgotPasswordLink}>
                Forgot Password?
              </MuiLink>
            )}
            {!hideSignup && (
              <Typography variant="body2" mt={1}>
                Don't have an account?{" "}
                <MuiLink component={Link} to="/client/register">
                  Sign up now
                </MuiLink>
              </Typography>
            )}
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default LoginForm;
